export const handleTrackReportClick = ({
  event,
  reportId,
  reportName,
  reportCategory = "",
  reportDivision = "",
  fileType = "",
  origin
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    data_report_id: reportId,
    data_report_name: reportName,
    data_report_category: reportCategory,
    data_report_division: reportDivision,
    data_report_file_type: fileType,
    data_report_origin: origin
  });
};
